export default __webpack_public_path__ + "static/typography-image-q-546871fa9053b1653bca8387a9afa858dfb65d816177740f7884d8a172006354.png";